"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigateConfirmation = exports.handleBlockedNavigation = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var react_router_dom_1 = require("react-router-dom");
var Types = require("types");
var NavigationActions = require("../../actions/navigation");
var GenericConfirmDialog_1 = require("components/GenericConfirmDialog");
var mapStateToProps = function (state) {
    return {
        navigation: state.navigation
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    setLocation: function (l) { return dispatch(NavigationActions.setLocation(l)); },
    confirm: function () { return dispatch(NavigationActions.setConfirmedNavigation(true)); },
    navigate: function (url) { return dispatch((0, connected_react_router_1.push)(url)); },
    clearNavigation: function () { return dispatch(NavigationActions.clearNavigation()); },
    setConfirmed: function () { return dispatch(NavigationActions.setConfirmedNavigation(false)); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.navigation.confirmedNavigation) {
            nextProps.navigate(nextProps.navigation.location);
        }
    },
    componentWillUnmount: function () {
        this.props.clearNavigation();
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.display !== nextProps.display ||
            this.props.isOpen !== nextProps.isOpen ||
            this.props.navigation.confirmedNavigation !==
                nextProps.navigation.confirmedNavigation) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var handleBlockedNavigation = function (props) { return function (nextLocation) {
    if (props.isOpen && props.display) {
        return props.isOpen;
    }
    if (!props.navigation.confirmedNavigation && props.display) {
        props.setLocation(nextLocation.pathname);
        props.setIsOpen(true);
        return false;
    }
    return true;
}; };
exports.handleBlockedNavigation = handleBlockedNavigation;
exports.NavigateConfirmation = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(react_router_dom_1.Prompt, { when: props.display, message: (0, exports.handleBlockedNavigation)(props) }),
    React.createElement(GenericConfirmDialog_1.GenericConfirmDialog, __assign({}, props)))); });
exports.default = exports.NavigateConfirmation;
